export default "__VITE_ASSET__DFk1zu02__"